

/*
 *   File : systematic-plan.js
 *   Author : https://evoqins.com
 *   Description : Systematic list
 *   Version : 1.0.0
*/

// packages
import { Fragment, useEffect, useState } from "react";

// components
import { CustomTitle } from "../../../Components/Title";
import { CustomTabBar } from "../../../Components/Tab";
import { DataTableContainer } from "../../../Components/DataTable";
import { CustomSelect } from "../../../Components/FormElements";
import { Icon } from "../../../Components/Icon";
import { EmptyScreen } from "../../../Components/Others";

// colors
import Colors from '../../../Styles/color.module.scss';

// services
import APIService from "../../../Services/api-service";


const TAB_DATA = [
    {
        label: "SIP",
        id: 1
    },
    {
        label: "SWP",
        id: 2
    },
    {
        label: "STP",
        id: 3
    }
]

const TAB_DATA1 = [
    {
        label: "Active",
        id: 1
    },
    {
        label: "Processed",
        id: 2
    },
    {
        label: "Cancelled",
        id: 3
    },
    {
        label: "Paused",
        id: 4
    },
    {
        label: "Completed",
        id: 5
    }
]

const INVESTMENT_TYPES = [
    {
        label: "Milestones",
        value: 1
    },
    {
        label: "Individual Funds",
        value: 2
    },
    {
        label: "Baksets",
        value: 3
    }
]


// Table custom style
const TABLE_STYLE = {
    table: {
        style: {
            borderRadius: "0px",
        },
    },

    headRow: {
        style: {
            borderBottomColor: 'transparent',
            paddingLeft: "24px",
            color: Colors.dark_gray,
            fontFamily: "Montserrat-Bold",
            fontSize: "14px",
            lineHeight: "24px",
            paddingTop: "0px",
            paddingBottom: '0px',

        }
    },
    rows: {
        style: {
            paddingLeft: "24px",
            borderBottom: 'none !important',
            '&:nth-child(odd)': {
                backgroundColor: '#0D0D0D05',
            },
            '&:hover': {
                backgroundColor: Colors.lavender_mist
            }

        },
    },
    cells: {
        style: {
            paddingTop: '16px',
            paddingBottom: '16px',
            color: Colors.dark_charcoal,
            fontFamily: "Montserrat-Medium",
            fontSize: "14px",
            lineHeight: "24px",
            paddingLeft: "0px",
            cursor: "pointer",
            userSelect: "none",
        }
    },
    headCells: {
        style: {
            paddingLeft: "0px"
        }
    },
    pagination: {
        style: {
            paddingRight: "50px",
            paddingTop: "10px",
            borderTop: "none"
        }
    }
};

const SystematicPlan = () => {
    const [selected, setSelected] = useState(TAB_DATA[0].id);
    const [selectedTab, setSelectedTab] = useState(TAB_DATA1[0].id);
    const [investmentType, setInvestmentType] = useState(INVESTMENT_TYPES[0]);
    const [sipData, setSipData] = useState({});
    const [stpData, setStpData] = useState({});
    const [swpData, setSwpData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [apiLoader, setApiLoader] = useState(true);
    const [customerList, setCustomerList] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);


    const SIP_ORDER_COLUMNS = [

        {
            name: "Name",
            cell: row => <div className="d-block">
                {
                    row.is_external === true &&
                    <div class="d-flex align-items-center gap-2px color-bright-periwinkle e-font-14 line-height-20px e-montserrat-medium mb-2">
                        <img src={require("../../../Assets/Images/Icons/external.svg").default}
                            alt="external"
                            width={18} />
                        External
                    </div>
                }
                <div className="d-flex align-items-center">
                    <img src={row.icon}
                        alt={row.name}
                        width={38}
                        height={38}
                        draggable={false}
                        className="border-radius-8px border-1px border-color-mint-gray" />
                    <span className="ps-2">{row.name}</span>
                </div>
            </div>,
            width: "300px"
        },

        {
            name: "Date",
            width: "200px",
            cell: row => row.date_str === null ? "-" : row.date_str,
            omit: selectedTab === 1 ? false : true
        },
        {
            name: "Next SIP due",
            width: "160px",
            cell: row => row.next_sip_date,
            omit: selectedTab === 1 ? false : true
        },

        {
            name: "Amount",
            width: "160px",
            cell: row => row.amount_text === null ? "-" : row.amount_text,
        },
        {
            name: "Executed date",
            width: "160px",
            cell: row => row.executed_date,
            omit: selectedTab === 2 ? false : true
        },
        {
            name: "Created on",
            width: "160px",
            cell: row => row.created,
            omit: (selectedTab >= 3) ? false : true
        },
        {
            name: "SIP date",
            width: "180px",
            cell: row => row.sip_date,
            omit: (selectedTab >= 3) ? false : true
        },
        {
            name: "Cancelled on",
            width: "160px",
            cell: row => <p className="color-deep-carmine-pink mb-0">{row.cancelled}</p>,
            omit: selectedTab === 3 ? false : true
        },

        {
            name: "Paused on",
            width: "160px",
            cell: row => <p className="color-navy-blue mb-0">{row.paused}</p>,
            omit: selectedTab === 4 ? false : true
        },
        {
            name: "Completed on",
            width: "160px",
            cell: row => row.completed_on,
            omit: selectedTab === 5 ? false : true
        },
        {
            name: "Status",
            omit: selectedTab === 2 ? false : true,
            selector: row => <div className="d-flex gap-4px align-items-center">
                <img src={row.status === "Successful" ? require("../../../Assets/Images/systematic-transactions/success.svg").default
                    :
                    require("../../../Assets/Images/systematic-transactions/failed.svg").default
                } alt={row.status}
                    width={20}
                    height={20}
                    draggable={false} />
                <p className={`e-montserrat-semi-bold e-font-14 e-line-height-20 mb-0 ${row.status === "Successful" ? "color-emerald-green" : "color-deep-carmine-pink"}`}>{row.status}</p>
            </div>,
            width: "140px",
            sortable: true,
        },

    ]

    const SWP_ORDER_COLUMNS = [

        {
            name: "Name",
            cell: row => <div className="d-block">
                {
                    row.is_external === true &&
                    <div class="d-flex align-items-center gap-2px color-bright-periwinkle e-font-14 line-height-20px e-montserrat-medium mb-2">
                        <img src={require("../../../Assets/Images/Icons/external.svg").default}
                            alt="external"
                            width={18} />
                        External
                    </div>
                }
                <div className="d-flex align-items-center">
                    <img src={row.icon}
                        alt={row.name}
                        width={38}
                        height={38}
                        draggable={false}
                        className="border-radius-8px border-1px border-color-mint-gray" />
                    <span className="ps-2">{row.name}</span>
                </div>
            </div>,
            width: "300px"
        },

        {
            name: "Date",
            width: "200px",
            cell: row => row.date_str === null ? "-" : row.date_str,
            omit: selectedTab === 1 ? false : true
        },
        {
            name: "Next SWP due",
            width: "160px",
            cell: row => row.next_swp_date,
            omit: selectedTab === 1 ? false : true
        },

        {
            name: "Amount",
            width: "160px",
            cell: row => row.amount_text === null ? "-" : row.amount_text,
        },
        {
            name: "Executed date",
            width: "160px",
            cell: row => row.executed_date,
            omit: selectedTab === 2 ? false : true
        },
        {
            name: "Created on",
            width: "160px",
            cell: row => row.created,
            omit: (selectedTab >= 3) ? false : true
        },
        {
            name: "SWP Schedule",
            width: "180px",
            cell: row => row.swp_date,
            omit: (selectedTab >= 3) ? false : true
        },
        {
            name: "Cancelled on",
            width: "160px",
            cell: row => <p className="color-deep-carmine-pink mb-0">{row.cancelled}</p>,
            omit: selectedTab === 3 ? false : true
        },

        {
            name: "Paused on",
            width: "160px",
            cell: row => <p className="color-navy-blue mb-0">{row.paused}</p>,
            omit: selectedTab === 4 ? false : true
        },
        {
            name: "Completed on",
            width: "160px",
            cell: row => row.completed_on,
            omit: selectedTab === 5 ? false : true
        },
        {
            name: "Status",
            omit: selectedTab === 2 ? false : true,
            selector: row => <div className="d-flex gap-4px align-items-center">
                <img src={row.status === "Successful" ? require("../../../Assets/Images/systematic-transactions/success.svg").default
                    :
                    require("../../../Assets/Images/systematic-transactions/failed.svg").default
                } alt={row.status}
                    width={20}
                    height={20}
                    draggable={false} />
                <p className={`e-montserrat-semi-bold e-font-14 e-line-height-20 mb-0 ${row.status === "Successful" ? "color-emerald-green" : "color-deep-carmine-pink"}`}>{row.status}</p>
            </div>,
            width: "140px",
            sortable: true,
        },

    ]

    const STP_ORDER_COLUMNS = [

        {
            name: "Name",
            cell: row => <div className="d-block">
                <p className="e-montserrat-regular e-font-14 e-line-height-20 color-outer-space mb-2">Transfer Out</p>
                <div className={`row gx-2`}>
                    <div className="d-block ">
                        {row.is_external === true && <div className="d-flex align-items-center gap-2px color-bright-periwinkle e-font-14 line-height-20px e-montserrat-medium mb-2">
                            <Icon icon="external" size={18}
                            /> External
                        </div>}
                        <div className="d-flex gap-8px align-items-center">
                            <img src={row.fund_out.icon}
                                width={48}
                                height={48}
                                alt={row.fund_out.name}
                                draggable={false}
                                className="border-radius-12px e-fund-detail-chart object-fit-contain" />
                            <p className="color-eerie-black e-font-14 e-line-height-20 e-montserrat-semi-bold mb-0 e-row-title">{row.fund_out.name}</p>
                        </div>
                    </div>
                  
                </div>
                <p className="e-montserrat-regular e-font-14 e-line-height-20 color-rebecca-purple mb-2 mt-3">Transfer In</p>
                <div className="d-flex gap-16px justify-content-between  e-bg-pastel-purple ">

                        <div className="d-flex gap-8px align-items-center">
                            <img src={row.fund_in.icon}
                                width={48}
                                height={48}
                                alt={row.fund_in.name}
                                draggable={false}
                                className="border-radius-12px e-fund-detail-chart object-fit-contain" />
                            <p className="color-eerie-black e-font-14 e-line-height-20 e-montserrat-semi-bold mb-0 e-row-title">{row.fund_in.name}</p>
                        </div>
                </div>
            </div>,
            omit: selectedTab === 1 ? false : true,
            width: "300px"
        },

        {
            name: "Name",
            omit: selectedTab === 1 ? true : false,
            cell: row => <div className="d-block">
                {
                    row.is_external === true &&
                    <div class="d-flex align-items-center gap-2px color-bright-periwinkle e-font-14 line-height-20px e-montserrat-medium mb-2">
                        <img src={require("../../../Assets/Images/Icons/external.svg").default}
                            alt="external"
                            width={18} />
                        External
                    </div>
                }
                <div className="d-flex align-items-center">
                    <img src={row.fund_out.icon}
                        alt={row.fund_out.name}
                        width={38}
                        height={38}
                        draggable={false}
                        className="border-radius-8px border-1px border-color-mint-gray" />
                    <span className="ps-2">{row.fund_out.name}</span>
                </div>
            </div>,
            width: "300px"
        },
        {
            name: "Date",
            width: "200px",
            cell: row => row.date_str === null ? "-" : row.date_str,
            omit: selectedTab === 1 ? false : true
        },
        {
            name: "Next STP",
            width: "160px",
            cell: row => row.next_stp_date,
            omit: selectedTab === 1 ? false : true
        },

        {
            name: "Amount",
            width: "160px",
            cell: row => row.amount_text === null ? "-" : row.amount_text,
        },
        {
            name: "Executed date",
            width: "160px",
            cell: row => row.executed_date,
            omit: selectedTab === 2 ? false : true
        },
        {
            name: "Created on",
            width: "160px",
            cell: row => row.created,
            omit: (selectedTab >= 3) ? false : true
        },
        {
            name: "STP schedule",
            width: "180px",
            cell: row => row.stp_date,
            omit: (selectedTab >= 3) ? false : true
        },
        {
            name: "Cancelled on",
            width: "160px",
            cell: row => <p className="color-deep-carmine-pink mb-0">{row.cancelled}</p>,
            omit: selectedTab === 3 ? false : true
        },

        {
            name: "Paused on",
            width: "160px",
            cell: row => <p className="color-navy-blue mb-0">{row.paused}</p>,
            omit: selectedTab === 4 ? false : true
        },
        {
            name: "Completed on",
            width: "160px",
            cell: row => row.completed_on,
            omit: selectedTab === 5 ? false : true
        },
        {
            name: "Status",
            omit: selectedTab === 2 ? false : true,
            selector: row => <div className="d-flex gap-4px align-items-center">
                <img src={row.status === "Successful" ? require("../../../Assets/Images/systematic-transactions/success.svg").default
                    :
                    require("../../../Assets/Images/systematic-transactions/failed.svg").default
                } alt={row.status}
                    width={20}
                    height={20}
                    draggable={false} />
                <p className={`e-montserrat-semi-bold e-font-14 e-line-height-20 mb-0 ${row.status === "Successful" ? "color-emerald-green" : "color-deep-carmine-pink"}`}>{row.status}</p>
            </div>,
            width: "140px",
            sortable: true,
        },

    ]

    useEffect(() => {
        _getCustomerList();
    }, []);

    useEffect(() => {
        if (selected === 1 && selectedCustomer !== null) {
            _getSips();
        }
        // eslint-disable-next-line
    }, [selected, investmentType, selectedTab, currentPage, selectedCustomer])

    useEffect(() => {
        if (selected === 2 && selectedCustomer !== null) {
            _getSwps();
        }
        // eslint-disable-next-line
    }, [selected, selectedTab, currentPage, selectedCustomer])

    useEffect(() => {
        if (selected === 3 && selectedCustomer !== null) {
            _getStps();
        }
        // eslint-disable-next-line
    }, [selected, selectedTab, currentPage, selectedCustomer])

    // API - customer search
    const _getCustomerList = () => {
        const url = "/user/search";
        const request = {
            query: ""
        }
        APIService(true, url, request).then((response) => {
            if (response.status_code === 200) {
                const customer_list = []
                customer_list.push({
                    label: "All",
                    value: null
                })
                response.data.map((item) => {
                    return (
                        customer_list.push({
                            label: item.name,
                            value: item.user_id
                        })
                    )
                })
                setCustomerList(customer_list);
                setSelectedCustomer(customer_list[0])
            }
        })
    }

    // API - SIP Lists
    const _getSips = () => {
        setApiLoader(true);
        const url = selectedTab === 1 ? "/user/sip/active-list" : selectedTab === 2 ? "/user/sip/processed-list" : selectedTab === 3 ? "/user/sip/cancelled-list" : selectedTab === 4 ? "/user/sip/paused-list" : "/user/sip/completed-list";
        const request = {
            "page_num": currentPage,
            "page_size": 12,
            "investment_type": investmentType.value,
            "customer_id": selectedCustomer?.value
        }
        APIService(true, url, request).then((response) => {
            if (response.status_code === 200) {
                setSipData(response.data);
            } else {
                setSipData({});
            }
            setApiLoader(false);
        });
    }

    // API - SWP Lists
    const _getSwps = () => {
        setApiLoader(true);
        const url = selectedTab === 1 ? "/user/swp/active-list" : selectedTab === 2 ? "/user/swp/processed-list" : selectedTab === 3 ? "/user/swp/cancelled-list" : selectedTab === 4 ? "/user/swp/paused-list" : "/user/swp/completed-list";
        const request = {
            "page_num": currentPage,
            "page_size": 12,
            "investment_type": 2,
            "customer_id": selectedCustomer?.value
        }
        APIService(true, url, request).then((response) => {
            if (response.status_code === 200) {
                setSwpData(response.data);
            } else {
                setSwpData({});
            }
            setApiLoader(false);
        });
    }

    // API - STP Lists
    const _getStps = () => {
        setApiLoader(true);
        const url = selectedTab === 1 ? "/user/stp/active-list" : selectedTab === 2 ? "/user/stp/processed-list" : selectedTab === 3 ? "/user/stp/cancelled-list" : selectedTab === 4 ? "/user/stp/paused-list" : "/user/stp/completed-list";
        const request = {
            "page_num": currentPage,
            "page_size": 12,
            "investment_type": 2,
            "customer_id": selectedCustomer.value
        }
        APIService(true, url, request).then((response) => {
            if (response.status_code === 200) {
                setStpData(response.data);
            } else {
                setStpData({});
            }
            setApiLoader(false);
        });
    }
    return (
        <Fragment>
            <div className="e-bg-light-lavender pt-3 padding-52px-lr">
                <CustomTitle title="Systematic Plans" type={1} />
            </div>
            <div className="e-body-wrapper padding-52px-lr ">
                <div className="bg-white border-radius-24px padding-32px-tb mt-4 ">
                    <div className=" padding-32px-lr">
                        <div className="row">
                            <div className="col-3 d-lg-block d-none">
                                <div className="e-box-shadow-white border-radius-24px">
                                    {
                                        TAB_DATA.map((item, key) =>
                                            <div className={`${selected === item.id ? "e-bg-light-lavender" : "cursor-pointer"} 
                                                        ${key === 0 && "border-radius-tlr-24px"} 
                                                        ${key !== TAB_DATA.length - 1 && "border-bottom-1px border-color-mint-gray"}
                                                        ${key === TAB_DATA.length - 1 && "border-radius-blr-24px"}
                                                        padding-18px-tb padding-12px-lr padding-22px-bottom `}
                                                key={key}
                                                onClick={() => {
                                                    if (item.id !== selected) {
                                                        setSelected(item.id);
                                                        setCurrentPage(1);
                                                    }
                                                }}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="d-flex align-items-center gap-8px">
                                                        <p className="e-montserrat-semi-bold e-font-14 e-line-height-24 color-eerie-black mb-0">{item.label}</p>
                                                    </div>
                                                    <Icon icon="arrow-right"
                                                        size={20} />
                                                </div>

                                            </div>
                                        )
                                    }

                                </div>

                            </div>
                            <div className="col-9">
                                <CustomTabBar data={TAB_DATA1}
                                    selectedTab={selectedTab}
                                    onSelectTab={(tab) => {
                                        setSelectedTab(tab);
                                        setCurrentPage(1);
                                    }} />
                                <div className="row">
                                    {selected === 1 && <div className="col-lg-3 pt-3">
                                        <CustomSelect options={INVESTMENT_TYPES}
                                            value={investmentType}
                                            selectChange={(select_value) => {
                                                setInvestmentType(select_value);
                                                setCurrentPage(1);
                                            }} />
                                    </div>}
                                    <div className="col-lg-3 pt-3">
                                        <CustomSelect value={selectedCustomer}
                                            options={customerList}
                                            isSearchable={true}
                                            selectChange={(value) => {
                                                setSelectedCustomer(value);
                                                setCurrentPage(1);
                                            }} />
                                    </div>
                                </div>
                                {
                                    apiLoader === true ?
                                        <div className="h-80vh d-flex align-items-center justify-content-center">
                                            <img src={require("../../../Assets/Images/loader/page-loader.gif")}
                                                alt={"loader"}
                                                width={60}
                                                height={60}
                                            />
                                        </div>
                                        :
                                        selected === 1 ?
                                            sipData.sips === undefined || sipData.sips.length === 0 ?
                                                <EmptyScreen
                                                    title={
                                                        currentPage > 1 ? "No data found , Please reload to reset data"
                                                            :
                                                            "No data found"
                                                    }
                                                    image={require("../../../Assets/Images/loader/empty-funds.png")}
                                                    description="Lorem Ipsum has been the industry's standard dummy text ever since the 1500s" />
                                                :
                                                <Fragment>
                                                    <DataTableContainer data={sipData.sips}
                                                        columns={SIP_ORDER_COLUMNS}
                                                        customStyles={TABLE_STYLE}
                                                        selectableRows={false}
                                                        paginationComponentOptions={{ noRowsPerPage: true }}
                                                        defaultSortFieldId={1}
                                                        pagination={true}
                                                        paginationServer={true}
                                                        perPage={12}
                                                        paginationTotalRows={sipData.total_sips}
                                                        onChangePage={(page) => setCurrentPage(page)}
                                                        paginationDefaultPage={currentPage}
                                                        selectRows={(allSelected, selectedCount, selectedRows) => {
                                                        }}
                                                        rowClick={() => { }}
                                                    />
                                                </Fragment>
                                            :
                                            selected === 2 ?
                                                swpData.swps === undefined || swpData.swps.length === 0 ?
                                                    <EmptyScreen
                                                        title={
                                                            currentPage > 1 ? "No data found , Please reload to reset data"
                                                                :
                                                                "No data found"
                                                        }
                                                        image={require("../../../Assets/Images/loader/empty-funds.png")}
                                                        description="Lorem Ipsum has been the industry's standard dummy text ever since the 1500s" />
                                                    :
                                                    <Fragment>
                                                        <DataTableContainer data={swpData.swps}
                                                            columns={SWP_ORDER_COLUMNS}
                                                            customStyles={TABLE_STYLE}
                                                            selectableRows={false}
                                                            paginationComponentOptions={{ noRowsPerPage: true }}
                                                            defaultSortFieldId={1}
                                                            pagination={true}
                                                            paginationServer={true}
                                                            perPage={12}
                                                            paginationTotalRows={swpData.total_swps}
                                                            onChangePage={(page) => setCurrentPage(page)}
                                                            paginationDefaultPage={currentPage}
                                                            selectRows={(allSelected, selectedCount, selectedRows) => {
                                                            }}
                                                            rowClick={() => { }}
                                                        />
                                                    </Fragment>
                                                :
                                                stpData.stps === undefined || stpData.stps.length === 0 ?
                                                    <EmptyScreen
                                                        title={
                                                            currentPage > 1 ? "No data found , Please reload to reset data"
                                                                :
                                                                "No data found"
                                                        }
                                                        image={require("../../../Assets/Images/loader/empty-funds.png")}
                                                        description="Lorem Ipsum has been the industry's standard dummy text ever since the 1500s" />
                                                    :
                                                    <Fragment>
                                                        <DataTableContainer data={stpData.stps}
                                                            columns={STP_ORDER_COLUMNS}
                                                            customStyles={TABLE_STYLE}
                                                            selectableRows={false}
                                                            paginationComponentOptions={{ noRowsPerPage: true }}
                                                            defaultSortFieldId={1}
                                                            pagination={true}
                                                            paginationServer={true}
                                                            perPage={12}
                                                            paginationTotalRows={stpData.total_stps}
                                                            onChangePage={(page) => setCurrentPage(page)}
                                                            paginationDefaultPage={currentPage}
                                                            selectRows={(allSelected, selectedCount, selectedRows) => {
                                                            }}
                                                            rowClick={() => { }}
                                                        />
                                                    </Fragment>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
export default SystematicPlan